import React, { useEffect } from 'react';
import { ProviderType } from '../../../app/models/ProviderType';
import useHandleErrorFields from '../../../hooks/useHandleErrorFields';

type Props = {
    providerType: ProviderType;
    setProviderType: (ProviderType: ProviderType) => void;
    errorFields?: any;
};

const ProviderTypeForm = ({ providerType, setProviderType, errorFields }: Props) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setProviderType({ ...providerType, [name]: value });
    };

    return (
        <>
            <div className="mb-2 row needs-validation">
                <label className="col-md-3 col-form-label">Tipo</label>
                <div className="col-md-9">
                    <input
                        name="name"
                        id="name"
                        type="text"
                        className={`form-control ${fieldHasError('name')}`}
                        value={providerType.name}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('name')}
                        placeholder="Ingrese el nombre del tipo de proveedor"
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('name')}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProviderTypeForm;
